import React, {useEffect, useState} from 'react';
import {
    Container,
    Menu,
    Icon, Header, Image,
    Grid,
    GridRow,
    GridColumn,
    Segment, List, ListItem, Button
} from 'semantic-ui-react'

import {useSelector, useDispatch} from "react-redux";
import withRouter from "../common/withRouter";
import {
    deviceAdapt,
    deviceAdaptResource
} from '../slices/adapt'

const ClinicianForm = (props) => {
    const dispatch = useDispatch();
    const {data} = useSelector((state) => ({
        data: state.adapt.data,
    }));

    document.title = "Clinician Form";

    useEffect(() => {
        window.scrollTo({top: 0, behavior: "smooth"})
    }, [])

    useEffect(() => {
        const params = new URLSearchParams(props.router.location.search);
        const patientId = params.get("patient_id")
        console.info(patientId)
        if (patientId) {
            dispatch(deviceAdapt(patientId, (data) => {
            }))
        } else {
            dispatch(deviceAdaptResource((data) => {
            }))
        }
    }, [dispatch, props])

    console.log(data)
    let patient = data ? data.custom_patient_discharge_patient_response : {}
    let getContent = (contents, color) => {
        let foundList50 = false
        let foundYoutube = false
        return contents && Array.isArray(contents) ? contents.map((item, index) => {
            if (!foundYoutube) {
                if (item.style === "h1") {
                    return <Header as={'h3'} style={{textAlign: "center", fontSize: 20, color, marginBottom: 20}}>
                        {item.text}
                    </Header>
                } else if (item.style === "h2") {
                    return <React.Fragment><span className={"h2"} style={{}}>
                    {item.text} </span> <br/> <br/> </React.Fragment>
                } else if (item.style === "normal") {
                    return item.text
                } else if (item.style === "bold") {
                    return <strong>{item.text}</strong>
                } else if (item.style === "list_50") {
                    if (!foundList50) {
                        foundList50 = true
                        let component = []
                        component.push(<GridColumn>
                            <List as='ul'>
                                {item.items.map(li => {
                                    return <ListItem as='li'><p
                                        style={{textAlign: "left"}}>{getListItem(li.elements)}</p>
                                    </ListItem>
                                })}
                            </List>
                        </GridColumn>)
                        component.push(<GridColumn>
                            <List as='ul'>{
                                contents[index + 1].items.map(li => {
                                    return <ListItem as='li'><p
                                        style={{textAlign: "left"}}>{getListItem(li.elements)}</p>
                                    </ListItem>
                                })
                            }
                            </List>
                        </GridColumn>)
                        return <Grid doubling columns={2}> {component}</Grid>
                    } else {
                        foundList50 = false
                    }
                } else if (item.style === "list") {
                    return <List as='ul'>
                        {item.items.map(li => {
                            return <ListItem as='li'><p style={{textAlign: "left"}}>{getListItem(li.elements)}</p>
                            </ListItem>
                        })}
                    </List>
                } else if (item.style === "center") {
                    return <p style={{textAlign: "center"}}>{getContent(item.body)}</p>
                } else if (item.style === "url") {
                    return <a href={item.url}>{item.text}</a>
                } else if (item.style === "image") {
                    return <div style={{
                        display: "flex",
                        alignContent: "center",
                        justifyContent: "center",
                        margin: 40
                    }}>
                        <Image fluid
                               size={"large"}
                               src={item.url}
                        />
                    </div>
                } else if (item.style === "youtube") {
                    foundYoutube = true
                    return <Grid doubling columns={2}>
                        <GridColumn width={8}>
                            <iframe width="320" height="200"
                                    title={""}
                                    src={"https://www.youtube.com/embed/LY98A-0oZQ4"}>
                            </iframe>
                            {/*<iframe src={"https://www.youtube.com/embed/LY98A-0oZQ4"}*/}
                            {/*        style={{width: "100%", height: "100%"}}/>*/}

                        </GridColumn>
                        <GridColumn width={8} style={{alignContent: "center"}}>
                            <div
                                style={{
                                    whiteSpace: "pre-wrap",
                                    fontSize: 16,
                                    textAlign: "left"
                                }}>
                                {getContent(contents.filter(thisyoutube => thisyoutube.style !== "youtube"))}
                            </div>
                        </GridColumn>
                    </Grid>
                } else {
                    return item.text
                }
            } else {
                return null
            }
        }) : contents
    }
    let getListItem = (contents, color) => {
        return contents && Array.isArray(contents) ? contents.map((item, index) => {
            if (item.style === "h1") {
                return <Header as={'h3'} style={{textAlign: "center", fontSize: 20, color}}>
                    {item.text}
                </Header>
            } else if (item.style === "h2") {
                return <React.Fragment><span className={"h2"} style={{}}>
                    {item.text} </span> <br/> <br/> </React.Fragment>
            } else if (item.style === "normal") {
                return item.text
            } else if (item.style === "bold") {
                return <strong>{item.text}</strong>
            } else {
                return item.text
            }
        }) : contents
    }

    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = width <= 768;
    return (
        <React.Fragment>
            <Menu fixed='top' inverted
                  style={{background: "linear-gradient(90deg, rgba(11,89,223,1) 0%, rgba(24,122,229,1) 49%, rgba(68,225,249,1) 100%)"}}>
                <Container>
                </Container>
            </Menu>
            <Container style={{marginTop: '3em', alignContent: "center"}}>
                <Grid reversed='computer' doubling columns={2}
                      style={{padding: 20, alignContent: "center"}}>
                    <GridColumn width={4} style={{
                        padding: 0,
                        paddingTop: 5,
                        alignContent: "center",
                        textAlign: isMobile ? "center" : "initial"
                    }}>
                        <Button className={'menu_button'}
                                icon
                                labelPosition='left'
                                onClick={() => {
                                    window.open("https://clinician.adapt4change.org/", "_self")
                                }}>
                            <Icon name='list alternate' size={"large"}/>
                            Clinician Form</Button>
                    </GridColumn>
                    <GridColumn width={12} style={{
                        padding: 0,
                        paddingTop: 15,
                        textAlign: isMobile ? "center" : "initial"
                    }}>
                        <Header as={'h4'} style={{cursor: "pointer"}} onClick={() => {
                            window.open("https://www.adapt4change.org/", "_self")
                        }}>
                            <span style={{color: "#0959DF"}}
                            >ADAPT4</span>Change
                        </Header>
                    </GridColumn>

                </Grid>
            </Container>
            <Container fluid style={{marginTop: '1em'}}>
                <br/>

                <div style={{
                    paddingRight: isMobile ? 0 : "1em",
                    paddingLeft: isMobile ? 0 : "1em",
                    marginTop: -10,
                    paddingBottom: isMobile ? "1em" : "5em",
                    paddingTop: isMobile ? "2em" : "3em"
                }}>

                    <Header as={'h2'}
                            style={{textAlign: "center", fontSize: 40, color: "#1A7E67", fontWeight: 700}}>
                        New Haven Resources
                    </Header>
                    <Container style={{
                        marginTop: '7em',
                        padding: isMobile ? 10 : 30,
                        borderRadius: 50,
                        backgroundImage: "linear-gradient(#1A7E67, #C4E2B2)"
                    }}>

                        <div style={{
                            display: "flex",
                            alignContent: "center",
                            justifyContent: "center",
                            marginTop: isMobile ? -60 : -80,
                        }}>
                            <Image fluid
                                   size={"small"}
                                   src={process.env.PUBLIC_URL + '/home.png'}
                                   style={{
                                       border: "3px solid #1A7E67",
                                       borderRadius: 30,
                                       backgroundColor: "white",
                                       padding: "13px 10px",
                                   }}
                            />
                        </div>
                        <Header as={'h3'} style={{textAlign: "center", fontSize: 28, color: "white"}}>
                            Where to Go
                        </Header>
                        <Header as={'h3'} style={{
                            textAlign: "center", fontSize: 20, color: "white",
                            marginLeft: '3vw',
                            marginRight: "3vw",
                        }}>
                            If you are struggling with opioid use, you are not alone. Help is available. There are a
                            variety of resources dedicated to supporting individuals with opioid use disorder.
                            Whether you’re seeking treatment, counseling, or community support, there are options.
                        </Header>
                        <br/>

                        {data &&
                            data.map(resource => {
                                const phonify = (text) => {
                                    var urlRegex = /(?:[-+() ]*\d){10,13}/gm;
                                    return text.replace(urlRegex, function (url) {
                                        return '<a href="tel:+' + url + '">' + url + '</a>';
                                    })
                                }
                                const urlify = (text) => {
                                    var urlRegex = /(https?:\/\/[^\s]+)/g;
                                    return text.replace(urlRegex, function (url) {
                                        return '<a target="_blank" href="' + url + '">' + url + '</a>';
                                    })
                                }
                                let contact = resource.data.contact ? phonify(resource.data.contact) : "";
                                let hours = resource.data.hours ? urlify(resource.data.hours) : "";
                                return <div style={{
                                    marginBottom: '3em',
                                    marginLeft: '3vw',
                                    marginRight: "3vw",
                                    borderRadius: 20,
                                    padding: isMobile ? 20 : 40,
                                    backgroundColor: "white"
                                }}>
                                    <Header as={'h3'} style={{
                                        textAlign: "center",
                                        fontSize: 20,
                                        color: "#1A7E67"
                                    }}>
                                        {resource.name}
                                    </Header>
                                    <Grid doubling columns={2}>
                                        <GridColumn>
                                            <p>
                                                <Icon size={"large"}
                                                      name={"map marker alternate"}
                                                      color={"teal"}/> {resource.data.location}
                                            </p>
                                        </GridColumn>
                                        <GridColumn>
                                            <p>
                                                <Icon size={"large"}
                                                      name={"time"}
                                                      color={"teal"}/> <span
                                                dangerouslySetInnerHTML={{__html: hours}}></span>
                                            </p>
                                        </GridColumn>
                                        <GridColumn>
                                            <p>
                                                <Icon size={"large"}
                                                      name={"phone"}
                                                      color={"teal"}/>
                                                <span
                                                    dangerouslySetInnerHTML={{__html: contact}}></span>
                                            </p>
                                        </GridColumn>
                                    </Grid>
                                    <br/>
                                    <p style={{textAlign: "justify"}}>
                                        <strong>Services </strong>: {resource.data.specifications}
                                    </p>
                                    {resource.data.locations?.map(location => {
                                        return <div style={{
                                            marginBottom: '2em',
                                            backgroundColor: "white"
                                        }}>
                                            <Header as={'h3'} style={{fontSize: 20, color: "#1A7E67"}}>
                                                {location.name}
                                            </Header>

                                            <Grid doubling columns={2}>
                                                <GridRow>
                                                    <GridColumn width={8}>
                                                        <p>
                                                            <Icon size={"large"}
                                                                  name={"map marker alternate"}
                                                                  color={"teal"}/> {location.location}
                                                        </p>
                                                    </GridColumn>
                                                    <GridColumn width={8}>
                                                        <p>
                                                            <Icon size={"large"}
                                                                  name={"time"}
                                                                  color={"teal"}/> {location.hours}
                                                        </p>
                                                    </GridColumn>
                                                </GridRow>
                                            </Grid>
                                        </div>
                                    })}
                                </div>
                            })}
                    </Container>
                </div>
            </Container>
            <footer>
                <p>
                    <span className={"header"}>This project was developed by Love Local Design and Yale School of Medicine
                        for the National Institute on Drug Abuse</span>
                    <br/>
                    <br/>
                    <span className={"subheader"}>This project was developed as part of the ADAPT study funded by the
                        National Institute for Drug Abuse (NIDA) to help
                        doctors use better ways to treat patients with opioid addiction in the emergency department.
                        The study looks at how doctors use special tools to start treatment for opioid addiction,
                        but it won’t collect any personal information like your name or phone number.
                        If you don’t want to be part of the study, you can call 203-737-2810 to opt out.
                        ADAPT: Adaptive Decision support for Addiction Treatment; (IRB Yale HIC Protocol Number:
                        2000038624).</span>
                </p>
            </footer>
        </React.Fragment>
    );
};

export default withRouter(ClinicianForm);
